<template>
  <div id="centerLeft1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">对下合同类型占比</span>
          <dv-decoration-3 class="dv-dec-3" />
        </div>
      </div>
      <div class="d-flex jc-center">
        <CenterLeft1Chart />
      </div>
      <div class="bottom-data">
        <div
          class="item-box"
          v-for="item in numberData"
          :key="item.text"
        >
          <span class="data-mark" :style="{ background: item.color }"></span>
          <strong :style="{ color: item.color }">{{ item.value }}</strong>
          <span class="data-unit">份</span>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CenterLeft1Chart from '@/components/echart/centerLeft/centerLeft1Chart'
export default {
  data() {
    return {
      numberData: [
        { text: '劳务合同', value: 52, color: '#20d8ce' },
        { text: '专业分包', value: 7, color: '#ff7184' },
        { text: '材料采购', value: 171, color: '#6d79ff' },
        { text: '设计/咨询', value: 19, color: '#ffb34d' }
      ]
    }
  },
  components: {
    CenterLeft1Chart
  }
}
</script>

<style lang="scss" scoped>
$box-height: 410px;

#centerLeft1 {
  padding: 16px;
  height: $box-height;
  width: 100%;
  border-radius: 10px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .dv-dec-3 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }

  .bottom-data {
    height: 76px;
    margin: 2px 14px 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 1px solid rgba(68, 190, 216, 0.14);
    .item-box {
      position: relative;
      padding-top: 10px;
      text-align: center;
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 14px;
        right: 0;
        width: 1px;
        height: 34px;
        background: rgba(89, 168, 198, 0.14);
      }
      .data-mark {
        display: inline-block;
        width: 5px;
        height: 5px;
        margin-right: 4px;
        border-radius: 50%;
        box-shadow: 0 0 7px currentColor;
      }
      strong {
        font-size: 20px;
        text-shadow: 0 0 10px rgba(63, 213, 222, 0.28);
      }
      .data-unit {
        margin-left: 2px;
        color: #7e8daa;
        font-size: 10px;
      }
      p {
        margin-top: 4px;
        color: #9aa8c0;
        font-size: 11px;
      }
    }
  }
}
</style>
